import { Color } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { ImporterType } from 'dashboard/models/importer';
import ImporterTypeIcon from 'dashboard/views/DashboardImporterStepperView/ImporterTypeIcon';
import StepperFormControlLabel from 'dashboard/views/DashboardImporterStepperView/StepperFormControlLabel';
import Button from 'design-system/components/Button';
import Card from 'design-system/components/Card/Card';

const DatabaseCard = styled(Button)<{ empty?: boolean; selected?: boolean }>`
  align-items: center;
  background-color: ${({ selected }) => (selected ? Color.CorePurple100 : Color.PrimaryWhite)};
  border-radius: 4px;
  border: ${({ empty }) => (empty ? 'none' : '1px solid #e6e6ea')};
  border: 1px solid ${({ selected }) => (selected ? Color.PrimaryPurple : Color.CoreSlate100)};
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
  padding: 12px;
  width: 100%; /* Equal widths */
  margin-bottom: 0;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  &:last-child {
    margin-bottom: 0;
  }
`;

interface ImporterTypeSelectorProps {
  importerTypes: { value: ImporterType; label: string }[];
  selectedImporterType: ImporterType;
  onSelectImporterType: (data: ImporterType) => void;
}

const ImporterTypeSelector = ({
  importerTypes,
  selectedImporterType,
  onSelectImporterType,
}: ImporterTypeSelectorProps) => {
  return (
    <>
      <StepperFormControlLabel>Select database</StepperFormControlLabel>
      <Row>
        {importerTypes.map((ip) => (
          <DatabaseCard
            selected={selectedImporterType === ip.value}
            key={ip.value}
            as={Card}
            onClick={() => onSelectImporterType(ip.value)}
          >
            <ImporterTypeIcon type={ip.label} />
            {ip.label}
          </DatabaseCard>
        ))}
      </Row>
    </>
  );
};

export default ImporterTypeSelector;
